'use client'
import { useEffect } from 'react'
import { AlertTriangle } from 'lucide-react'

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => { console.error(error) }, [error])
  return (
    <html>
      <body className="min-h-screen bg-[#0F1117] flex items-center justify-center p-8">
        <div className="max-w-md text-center">
          <AlertTriangle className="h-12 w-12 text-red-400 mx-auto mb-4" />
          <h2 className="text-[20px] font-bold text-white mb-2">Something went wrong</h2>
          <p className="text-[13px] text-gray-400 mb-6">An unexpected error occurred. Please try again.</p>
          <button onClick={reset} className="rounded-[8px] bg-purple-600 text-white px-6 py-2 text-[13px] font-semibold hover:bg-purple-700">
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
